import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,

  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
type Props = {};
const VehicleTypeAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const [toaster, setToaster] = useState(false);
  const initialRowData = {
    activeClass: "",
    all: true,
    showExisting: true,
    isSuccess: true,
    message: "",
    srno: 0,
    eScarp: true||false,
    eScarpPrevValue: "",
    css: "",
    vehicleTypeId: 0,
    vehicleTypename: "",
    shortName: "",
    vehicleCode: "",
    createdBy: "",
    updatedBy: "",
    createdOn: defaultValues,
    updatedOn: defaultValues,
    checked: true
  };
  // const [itemOption, setitemOption] = useState([
  //   { value: -1, label: t("text.itemMasterId") },
  // ]);

  useEffect(() => {
    // getVendorData();

  }, []);

  const formik = useFormik({
    initialValues: {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      
      "srno": 0,
      "eScarp": true||false,
      "eScarpPrevValue": "",
      "css": "",
      "vehicleTypeId": 0,
      "vehicleTypename": "",
      "shortName": "",
      "vehicleCode": "",
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValues,
      "updatedOn": defaultValues,
      "checked": true

    },

    validationSchema: Yup.object({
      vehicleTypename: Yup.string()
        .required(t("text.reqVehicleType")),
        // .min(2, "Vehicle Type Name must be at least 2 characters")
        // .max(50, "Vehicle Type Name cannot exceed 50 characters"),
        vehicleCode: Yup.string()
        .required(t("text.reqVehicleCode")),
        // .min(1, "Vehicle Code must be at least 1 character")
        // .max(10, "Vehicle Code cannot exceed 10 characters"),
        shortName: Yup.string()
        .required(t("text.reqShortName")),
        // .min(2, "Short Name must be at least 2 characters")
        // .max(20, "Short Name cannot exceed 20 characters"),
    }),

    onSubmit: async (values) => {
      // values.vendor = vendorDetail;

      const response = await api.post(`VehicleType/AddUpdateEscrapVehicleType`, values);
      if (response.data.status===1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicletype");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });
  const back = useNavigate();
  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleTypeAdd")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.VehicleTypeName1")}
                  value={formik.values.vehicleTypename}
                  onChangeText={(text: string) => formik.setFieldValue("vehicleTypename", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.vehicleTypename && formik.errors.vehicleTypename ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.vehicleTypename}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.VehicleCode")}
                      required={true}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="vehicleCode"
                  id="vehicleCode"
                  placeholder={t("text.VehicleCode")}
                  value={formik.values.vehicleCode}
                  onChange={formik.handleChange}
                />
                {formik.touched.vehicleCode && formik.errors.vehicleCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.vehicleCode}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.VehicleShortName")}
                  value={formik.values.shortName}
                  onChangeText={(text: string) => formik.setFieldValue("shortName", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.shortName && formik.errors.shortName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.shortName}
                  </div>
                ) : null}
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.VehicleTypeName1")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="vehicleTypename"
    id="vehicleTypename"
    placeholder={t("text.VehicleTypeName1")}
    value={formik.values.vehicleTypename}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
   // required={true}
  />
  {formik.touched.vehicleTypename && formik.errors.vehicleTypename ? (
    <div style={{ color: "red", margin: "5px" }}>
      {t(formik.errors.vehicleTypename)}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.VehicleCode")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="vehicleCode"
    id="vehicleCode"
    placeholder={t("text.VehicleCode")}
    value={formik.values.vehicleCode}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
  />
  {formik.touched.vehicleCode && formik.errors.vehicleCode ? (
    <div style={{ color: "red", margin: "5px" }}>
      {t(formik.errors.vehicleCode)}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.VehicleShortName")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="shortName"
    id="shortName"
    placeholder={t("text.VehicleShortName")}
    value={formik.values.shortName}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    //required={true}
  />
  {formik.touched.shortName && formik.errors.shortName ? (
    <div style={{ color: "red", margin: "5px" }}>
      {t(formik.errors.shortName)}
    </div>
  ) : null}
</Grid>

              {/* <Grid item lg={12} xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        // checked={formik.values.qcApplicable}
                        onChange={formik.handleChange}
                        name="eScarp"
                      />
                    }
                    label={t("text.eScarp")}
                  />
                </FormGroup>
              </Grid> */}

<Grid item lg={12} xs={12}>
                                <FormControlLabel
                                    id="eScarp"
                                    name="eScarp"
                                    value={formik.values.eScarp}
                                    control={<Checkbox />} label={t("text.eScarp1")} />
                            </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleTypeAdd;